// Runner card open/close with browser-history support (phone Back closes it).
//
//   open  -> history.pushState({runner: id}, '', '#<id>') (replaceState if an
//            entry of ours is already on the stack, so Back needs one press)
//   close -> history.back() when we pushed the entry, otherwise just close and
//            strip a matching #runner-... hash left by a direct link
//   popstate -> closes any open runner (or re-opens one when going forward)
//
// `.expanded` on the card is the only open state; aria-expanded on the
// .rc-compact header mirrors it via setExpanded().

let pushed = false;

export function _resetForTests() {
  pushed = false;
}

export function isPushed() {
  return pushed;
}

function headerOf(card) {
  return card.querySelector('.rc-compact');
}

// The one place that flips a card open/closed and keeps aria-expanded in sync.
export function setExpanded(card, open) {
  card.classList.toggle('expanded', !!open);
  const head = headerOf(card);
  if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
}

function closeOthers(card) {
  const scope = card.closest('.race-runners') || card.ownerDocument;
  scope.querySelectorAll('.runner-card.expanded').forEach((c) => {
    if (c !== card) setExpanded(c, false);
  });
}

function keepInView(card) {
  const head = headerOf(card) || card;
  if (typeof head.scrollIntoView === 'function') head.scrollIntoView({ block: 'nearest' });
}

export function openRunner(card, { push = true } = {}) {
  closeOthers(card);
  setExpanded(card, true);
  if (push && card.id) {
    if (pushed) window.history.replaceState({ runner: card.id }, '', '#' + card.id);
    else window.history.pushState({ runner: card.id }, '', '#' + card.id);
    pushed = true;
  }
}

export function closeRunner(card) {
  setExpanded(card, false);
  if (pushed) {
    pushed = false;
    window.history.back();
  } else if (card.id && window.location.hash === '#' + card.id) {
    const { pathname, search } = window.location;
    window.history.replaceState(null, '', pathname + search);
  }
  keepInView(card);
}

// Header tap: open if closed, close if open.
// push=false (e.g. several races on one page, ids not unique) skips history.
export function toggleRunner(card, { push = true } = {}) {
  if (card.classList.contains('expanded')) closeRunner(card);
  else openRunner(card, { push });
}

export function onPopState(event, root = document) {
  const id = event && event.state && event.state.runner;
  const card = id ? root.getElementById(id) : null;
  if (card) {
    pushed = true;
    openRunner(card, { push: false });
    return;
  }
  pushed = false;
  root.querySelectorAll('.runner-card.expanded').forEach((c) => setExpanded(c, false));
}

let bound = false;
export function initRunnerHistory() {
  if (bound) return;
  bound = true;
  window.addEventListener('popstate', (e) => onPopState(e));
}
